import * as l from "react";
import { c as m } from "./index-DLcqcWxM.js";
import { jsx as u } from "react/jsx-runtime";
// @__NO_SIDE_EFFECTS__
function b(e) {
  const n = /* @__PURE__ */ y(e), o = l.forwardRef((t, r) => {
    const { children: i, ...c } = t, s = l.Children.toArray(i), f = s.find(E);
    if (f) {
      const a = f.props.children, d = s.map((p) => p === f ? l.Children.count(a) > 1 ? l.Children.only(null) : l.isValidElement(a) ? a.props.children : null : p);
      return /* @__PURE__ */ u(n, { ...c, ref: r, children: l.isValidElement(a) ? l.cloneElement(a, void 0, d) : null });
    }
    return /* @__PURE__ */ u(n, { ...c, ref: r, children: i });
  });
  return o.displayName = `${e}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function y(e) {
  const n = l.forwardRef((o, t) => {
    const { children: r, ...i } = o;
    if (l.isValidElement(r)) {
      const c = S(r), s = C(i, r.props);
      return r.type !== l.Fragment && (s.ref = t ? m(t, c) : c), l.cloneElement(r, s);
    }
    return l.Children.count(r) > 1 ? l.Children.only(null) : null;
  });
  return n.displayName = `${e}.SlotClone`, n;
}
var g = Symbol("radix.slottable");
function E(e) {
  return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === g;
}
function C(e, n) {
  const o = { ...n };
  for (const t in n) {
    const r = e[t], i = n[t];
    /^on[A-Z]/.test(t) ? r && i ? o[t] = (...s) => {
      i(...s), r(...s);
    } : r && (o[t] = r) : t === "style" ? o[t] = { ...r, ...i } : t === "className" && (o[t] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...o };
}
function S(e) {
  var t, r;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = n && "isReactWarning" in n && n.isReactWarning;
  return o ? e.ref : (n = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = n && "isReactWarning" in n && n.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
export {
  b as c
};
//# sourceMappingURL=index-CM5R_ZZi.js.map
